module.exports = "/assets/452496c4a101ea7d98b7471f89a3f53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JF.png
// module id = 2632
// module chunks = 0